import * as types from 'constants/ActionTypes.js';
import { ROOT_URL } from 'constants/Config.js';

import axios from 'axios';

import { createRequestActions } from 'actions';

export function loadCollections(data, updateOnlyTotal = false) {
  return dispatch => {
    dispatch({ type: types.LOAD_COLLECTIONS_START });
    return axios.get(`${ROOT_URL}/selection/lists`, { params: data }).then((res) => {
      dispatch({ type: types.LOAD_COLLECTIONS_SUCCESS, payload: { ...res.data, updateOnlyTotal } });
    }).catch(error => {
      dispatch({ type: types.LOAD_COLLECTIONS_ERROR, payload: { error } });
    });
  };
}

export function checkBuilding(data) {
  return dispatch => {
    dispatch({ type: types.CHECK_BUILDING_START });
    return axios.get(`${ROOT_URL}/selection/check/buildings`, { params: data }).then((res) => {
      dispatch({ type: types.CHECK_BUILDING_SUCCESS, payload: res.data });
    }).catch(error => {
      dispatch({ type: types.CHECK_BUILDING_ERROR, payload: { error } });
    });
  };
}

export function loadCollection(data) {
  return dispatch => {
    dispatch({ type: types.LOAD_COLLECTION_START });
    return axios.get(`${ROOT_URL}/selection/lists/buildings`, { params: data }).then((res) => {
      dispatch({ type: types.LOAD_COLLECTION_SUCCESS, payload: res.data });
      return res.data;
    }).catch(error => {
      dispatch({ type: types.LOAD_COLLECTION_ERROR, payload: { error: error.response.data.error } });
    });
  };
}

export function loadPublicCollection(data) {
  return dispatch => {
    dispatch({ type: types.LOAD_COLLECTION_START });
    return axios.get(`${ROOT_URL}/selection/list/buildings`, { params: data }).then((res) => {
      dispatch({ type: types.LOAD_COLLECTION_SUCCESS, payload: res.data });
      return res.data;
    }).catch(error => {
      dispatch({ type: types.LOAD_COLLECTION_ERROR, payload: { error } });
    });
  };
}

export function loadCollectionBuilding(data) {
  return dispatch => {
    dispatch({ type: types.LOAD_COLLECTION_BUILDING_START });
    return axios
      .get(`${ROOT_URL}/selection/get/buildings`, { params: data })
      .then((res) => {
        dispatch({ type: types.LOAD_COLLECTION_BUILDING_SUCCESS, payload: res.data });
        return res.data;
      })
      .catch(error => {
        dispatch({ type: types.LOAD_COLLECTION_BUILDING_ERROR, payload: { error: error.response.data.error } });
      });
  };
}

export function loadRefBuilding(data) {
  return dispatch => {
    dispatch({ type: types.LOAD_COLLECTION_BUILDING_START });
    return axios
      .get(`${ROOT_URL}/selection/building/get`, { params: data })
      .then((res) => {
        dispatch({ type: types.LOAD_COLLECTION_BUILDING_SUCCESS, payload: res.data });
        return res.data;
      })
      .catch(error => {
        dispatch({ type: types.LOAD_COLLECTION_BUILDING_ERROR, payload: { error: error.response.data.error } });
      });
  };
}

export function createCollection(data) {
  return dispatch => {
    dispatch({ type: types.CREATE_COLLECTION_START });
    return axios.post(`${ROOT_URL}/selection/in`, data).then((res) => {
      dispatch({ type: types.CREATE_COLLECTION_SUCCESS, payload: res.data });
    }).catch(error => {
      dispatch({ type: types.CREATE_COLLECTION_ERROR, payload: error });
    });
  };
}

export function renameCollection(data) {
  return dispatch => {
    dispatch({ type: types.RENAME_COLLECTION_START });
    return axios.post(`${ROOT_URL}/selection/edit`, data).then((res) => {
      dispatch({ type: types.RENAME_COLLECTION_SUCCESS, payload: data });
    }).catch(error => {
      dispatch({ type: types.RENAME_COLLECTION_ERROR, payload: error });
    });
  };
}

export function dupCollection(data) {
  return dispatch => {
    dispatch({ type: types.DUP_COLLECTION_START });
    return axios.post(`${ROOT_URL}/selection/duplicate`, data).then((res) => {
      dispatch({ type: types.DUP_COLLECTION_SUCCESS, payload: res.data });
    }).catch(error => {
      dispatch({ type: types.DUP_COLLECTION_ERROR, payload: error });
    });
  };
}

export function deleteCollection(data) {
  return dispatch => {
    dispatch({ type: types.DELETE_COLLECTION_START });
    return axios.post(`${ROOT_URL}/selection/delete`, data).then((res) => {
      dispatch({ type: types.DELETE_COLLECTION_SUCCESS, payload: data });
    }).catch(error => {
      dispatch({ type: types.DELETE_COLLECTION_ERROR, payload: error });
    });
  };
}

export function addToCollection(data, meta) {
  return dispatch => {
    dispatch({ type: types.ADD_TO_COLLECTION_START });
    return axios.post(`${ROOT_URL}/selection/add/building`, data).then((res) => {
      dispatch({ type: types.ADD_TO_COLLECTION_SUCCESS, payload: data, meta });
    }).catch(error => {
      console.log(error);
      dispatch({ type: types.ADD_TO_COLLECTION_ERROR, payload: error });
    });
  };
}

export function shareBuilding(data) {
  const { buildingId } = data;

  return dispatch => {
    dispatch({ type: types.SHARE_BUILDING_REQUEST });

    return axios
      .post(`${ROOT_URL}/selection/building/add`, { building_id: buildingId })
      .then((res) => {
        dispatch({ type: types.SHARE_BUILDING_SUCCESS, payload: res.data });
        return res;
      })
      .catch(error => {
        dispatch({ type: types.SHARE_BUILDING_ERROR, payload: error });
      });
  };
}

export function removeFromCollection(data, meta) {
  return dispatch => {
    dispatch({ type: types.REMOVE_FROM_COLLECTION_START });
    return axios.post(`${ROOT_URL}/selection/building/delete`, data).then((res) => {
      dispatch({
        type: types.REMOVE_FROM_COLLECTION_SUCCESS,
        payload: data,
        meta: {
          ...meta,
          cancel: addToCollection.bind(null, data, { ...meta, cancelation: true })
        }
      });
    }).catch(error => {
      dispatch({ type: types.REMOVE_FROM_COLLECTION_ERROR, payload: error });
    });
  };
}

export function removeChessFromCollection(data, meta) {
  return dispatch => {
    dispatch({ type: types.REMOVE_FROM_COLLECTION_START });
    return axios.post(`${ROOT_URL}/selection/building/delete/chess`, data).then((res) => {
      dispatch({
        type: types.REMOVE_FROM_COLLECTION_SUCCESS,
        payload: data,
        meta: {
          ...meta,
          cancel: addToCollection.bind(null, data, { ...meta, cancelation: true })
        }
      });
    }).catch(error => {
      dispatch({ type: types.REMOVE_FROM_COLLECTION_ERROR, payload: error });
    });
  };
}

export function addComment(data) {
  return dispatch => {
    dispatch({ type: types.COMMENT_COLLECTION_START });
    return axios.post(`${ROOT_URL}/selection/building/comment`, data).then((res) => {
      dispatch({ type: types.COMMENT_COLLECTION_SUCCESS, payload: data });
    }).catch(error => {
      dispatch({ type: types.COMMENT_COLLECTION_ERROR, payload: error });
    });
  };
}

export const switchInfoAccess = createRequestActions({
  type: 'SWITCH_INFO_ACCESS',
  url: '/selection/show/info',
  method: 'post'
});



// WEBPACK FOOTER //
// ./src/actions/collections.js